<template>
	<div>
		<el-card>
			<div v-if="getFormConfig" slot="header">
				<span v-html="clearPLabel(getFormConfig.label)"></span>
				<span v-if="addPriceType && isAdd" class="red-bold">
					{{ `（ 批增按${addPriceType === 'M' ? '月' : '天'}收取保费 ）` }}
				</span>
			</div>
			<el-alert
				v-if="getFormConfig && getFormConfig.notice"
				:title="getFormConfig.notice.content"
				show-icon
				style="margin-bottom: 10px"
				type="warning"></el-alert>

			<avue-form
				ref="refPeriod"
				v-model="formPeriod"
				v-loading="isLoading"
				:option="optionPeriod"
				@submit="onSubmitPeriod">
				<template #today="{value}">
					<span>{{ value }}</span>
				</template>
				<template #expiryDate="{value}">
					<span>{{ value }}</span>
				</template>
				<template #periodDay="{value}">
					<span class="red-bold">{{ value }} 天</span>
				</template>
				<template #menuForm="{}">
					<el-button v-if="!optionPeriod.submitBtn" icon="el-icon-edit" @click="onCheckPeriodResult(false)">
						修改
					</el-button>
				</template>
			</avue-form>
		</el-card>

		<!--弹窗-->
		<dialog-endorse-time-hint
			ref="refTimeHint"
			:last-time-data="getLastDate"
			@onEndorseTimeSure="onShowInsureData"></dialog-endorse-time-hint>
	</div>
</template>

<script>
import EndorseTimeHintDialog from '@/components/insurance/endorseTimeHintDialog.vue'
import {getFgkDiantiPeriod} from '@/util/channelUtil'
import {toYYYYmmdd} from '@/util/date'
import {checkEffectiveDate, getChannelMainInfo} from '@/views/insuranceCenter/api/insureApiNew'
import DialogEndorseTimeHint from '@/views/insuranceCenter/components/other/dialogEndorseTimeHint.vue'
import {getInsureBaseConfig} from 'meibao-insure/src/api/productCenterNew'
import {basePeriodOption, getCompleteOption} from 'meibao-insure/src/option/baseOption'
import {clearPLabel} from 'meibao-insure/src/util/commonUtils'
import {getCurrentYYYYmmdd, getInsureEndTime, toYYYYmmddFullDate} from 'meibao-insure/src/util/dateUtil'
import {mapGetters} from 'vuex'

export default {
	name: 'formPeriodNew',
	components: {EndorseTimeHintDialog, DialogEndorseTimeHint},
	props: {
		insureType: String | Number,
		productId: String | Number,
		sourceProductId: String | Number,
		isAdd: {
			type: Boolean,
			default: false,
		},
		policyFormAllData: {
			type: Object,
			default: () => {
				return {}
			},
		},
		addPriceType: String,
	},
	data() {
		return {
			//option
			isLoading: false,
			optionPeriod: {},
			formPeriod: {
				today: '',
				effectiveDate: '',
				term: '',
				expiryDate: '',
			},
			isDealYear: false,
			//批增原起始日期
			effectiveBeginDate: '',
			choiceDataRange: [],
			lastTerm: '-1',
			isNeedCheck: false,
		}
	},
	computed: {
		...mapGetters(['userInfo']),
		getFormConfig() {
			if (this.validatenull(this.policyFormAllData.config)) {
				return ''
			}
			return this.policyFormAllData.config
		},
		//获取提醒日期
		getLastDate() {
			let {effectiveDate = ''} = this.formPeriod
			if (!this.isAdd || effectiveDate === '') {
				return []
			}
			return [effectiveDate, toYYYYmmdd(Date.parse(effectiveDate) - 24 * 60 * 60 * 1000)]
		},
		getTermData() {
			let {term = ''} = this.formPeriod
			if (term && term.includes('_')) {
				term = term.split('_')[0]
			}
			return parseInt(term)
		},
	},
	watch: {
		policyFormAllData: {
			handler(newVal) {
				//处理数据
				this.optionPeriod = getCompleteOption(
					this.policyFormAllData,
					basePeriodOption(this.policyFormAllData, this.isAdd),
				)
				//保障期限选项，如果只有一个选择，默认为第一个
				this.optionPeriod.column.forEach((itemData) => {
					let {dicData = [], prop = '', range = []} = itemData
					if (dicData.length === 1) {
						let {value, addition: {termUnit = ''} = {}} = dicData[0]
						this.formPeriod[prop] = `${value}_${termUnit ? termUnit : 'M'}`
					}
					if (range.length > 0) {
						this.choiceDataRange = range
					}
					if (prop === 'term' && this.envConfig.isBxIe()) {
						itemData.dicData = getFgkDiantiPeriod(dicData, this.insureType)
					}
				})
				if (!this.isAdd) {
					//处理日 月选择单位
					this.onDealUnit()
				}
				//ie保需要处理延迟时间
				this.onDelayTime()
				console.log('this.optionPeriod---', this.optionPeriod)
			},
			immediate: true,
		},
		//重构，分开监听
		'formPeriod.effectiveDate'(newVal) {
			//触发计算保费
			let {term = ''} = this.formPeriod
			this.onWatchData(newVal, term && term !== this.lastTerm)
		},
		'formPeriod.term'(newVal) {
			if (!this.isAdd) {
				//触发计算保费
				this.onWatchData(newVal, true)
				if (newVal) {
					//处理显隐
					this.onChangeOption(newVal)
				}
			}
		},
		'formPeriod.termVersion'(newVal) {
			//如果存在，则计算保费
			if (newVal) {
				this.isLoading = true
				this.onSendCalc()
			}
		},
	},
	mounted() {
		console.log('onBusEffectiveData-----')
		this.formPeriod.today = getCurrentYYYYmmdd()
		this.onSendCalc = _.debounce(this.onSendCalc, 500)
		this.$Bus.$on('onBusEffectiveData', this.onChangeEffectiveData)
	},
	activated() {
		this.$Bus.$on('onBusEffectiveData', this.onChangeEffectiveData)
	},
	deactivated() {
		this.$Bus.$off('onBusEffectiveData', this.onChangeEffectiveData)
	},
	methods: {
		clearPLabel,
		//触发全部填写数据，并且计算保费
		async onWatchData(newVal = '', isCheck = false) {
			if (!this.validatenull(newVal)) {
				try {
					this.isLoading = true
					if (!this.isAdd) {
						let tempData = this.deepClone(this.formPeriod)
						let {effectiveDate = '', term = ''} = tempData
						//判断是否所有数据都好了
						if (!effectiveDate || !term) {
							console.error('formPeriod-----数据没有有全部填写', tempData)
							this.isLoading = false
							return
						}
						if (isCheck || !this.isNeedCheck) {
							this.isNeedCheck = true
							//获取日期范围，并且判断是否变化
							if (!(await this.onGetPeriodRange(tempData))) {
								this.formPeriod.expiryDate = ''
								this.isLoading = false
								return
							}
						}
					}
					//计算保险止期
					this.calcDefeasanceDate()
					//计算保费
					this.onSendCalc()
				} catch (e) {
					this.$alert(e.message || '保障期限有误！', '提示').then(() => {})
					this.formPeriod.expiryDate = ''
					this.formPeriod.effectiveDate = ''
					this.isLoading = false
				} finally {
				}
			}
		},
		//发送计算保费消息
		onSendCalc() {
			//如果没有全部 选完，则返回
			if (this.isAllDataNoReady(this.formPeriod)) {
				console.error('formPeriod-----数据没有有全部填写', this.formPeriod)
				this.isLoading = false
				return
			}
			//修改数据，则需要重新计算保费
			this.$emit('onNeedCalcPrice', true)
			setTimeout(() => {
				this.isLoading = false
			}, 500)
		},
		async onSubmitPeriod(form, done) {
			let {effectiveDate} = this.formPeriod
			let {data = {}} = (await checkEffectiveDate({effectiveDate: effectiveDate})) || {}
			done()
			let {code = -1} = data
			if (code === 0) {
				if (!this.isAdd) {
					this.onCheckPeriodResult(true)
				} else {
					let tempData = Date.parse(`${this.choiceDataRange[0]} 00:00:00`)
					//计算时间
					let tempNum = this.daysBetween(tempData, Date.parse(effectiveDate))
					//大于最低时间
					if (tempNum > 1) {
						//显示弹窗
						this.$refs.refTimeHint.onShowDialog()
					} else {
						//判断批增日期
						this.onShowInsureData()
					}
				}
			}
		},
		//ture,确定，false 取消
		onCheckPeriodResult(result) {
			this.optionPeriod.submitBtn = !result
			this.optionPeriod.column.forEach((item, index) => {
				let {type = '', dicData = []} = item
				if (type !== '' && dicData.length !== 1) {
					item.disabled = result
				}
			})
			if (result) {
				//修改数据，则需要重新计算保费
				this.$emit('onPeriodChange', {type: 4, ...this.formPeriod})
			}
		},
		onGetSubPeriodData() {
			let tempPeriodData = this.deepClone(this.formPeriod)
			if (this.isAllDataNoReady(tempPeriodData)) {
				return {}
			}
			this.onClearOtherData(tempPeriodData)
			//判断选项中term有么有 _单位
			let {term = ''} = tempPeriodData
			if (term && term.includes('_')) {
				let [one, two] = term.split('_')
				tempPeriodData.term = one
				tempPeriodData.termUnit = two
			}
			return tempPeriodData
		},
		onSetPeriodData(data) {
			let {term = '', termUnit = '', expiryDate = '', effectiveDate = ''} = data
			//是否处理term
			let isDealTerm = true
			//批增
			if (this.isAdd) {
				this.formPeriod.expiryDate = toYYYYmmddFullDate(expiryDate)
				this.effectiveBeginDate = `${toYYYYmmdd(effectiveDate)} 00:00:00`
			} else {
				//处理单位
				let tempTerm = this.findObject(this.optionPeriod.column, 'term')
				let {dicData = []} = tempTerm || {}
				if (dicData.length <= 0 || !dicData[0].value.includes('_')) {
					isDealTerm = false
				}
			}
			if (term && isDealTerm) {
				term = `${term}`
				if (!term.includes('_')) {
					term = `${term}_${termUnit ? termUnit : 'M'}`
				}
			}
			let {term: termY = ''} = this.formPeriod
			//如果是续保进来的，term不为空，并且不存在，则去除
			if (!termY) {
				Object.assign(this.formPeriod, {term})
			} else {
				termY = `${termY}`
				if (!termY.includes('_')) {
					this.formPeriod.term = `${termY}_${termUnit ? termUnit : 'M'}`
				}
			}
			this.calcDefeasanceDate()
		},
		// 计算保单失效日期
		calcDefeasanceDate() {
			let {effectiveDate = '', term = '', expiryDate = ''} = this.formPeriod || {}
			if (effectiveDate === '' || term === '') {
				return
			}
			let beginDate = new Date(effectiveDate)
			if (!this.validatenull(beginDate)) {
				//查找可选时间
				if (this.choiceDataRange.length <= 0) {
					this.$alert('限制投保时间有误，请刷新浏览器重新投保！', '提示').then(() => {})
				} else {
					let [min, max] = this.choiceDataRange
					if (
						beginDate.getTime() < new Date(`${min} 00:00:00`).getTime() ||
						beginDate.getTime() > new Date(`${max} 00:00:00`).getTime()
					) {
						//错误提示
						this.onHintEffectiveDateError()
					} else {
						//如果为批增，则计算保障期限
						if (this.isAdd) {
							this.formPeriod.periodDay = this.daysBetween(beginDate.getTime(), new Date(expiryDate).getTime())
						} else {
							this.formPeriod.expiryDate = getInsureEndTime(beginDate, term) + ' 23:59:59'
							if (this.formPeriod.expiryDate.includes('NaN-NaN-NaN')) {
								//错误提示
								this.onHintEffectiveDateError()
							}
						}
					}
				}
			}
		},
		//生效日期选择时间有误，限制提醒
		onHintEffectiveDateError() {
			this.formPeriod.effectiveDate = ''
			this.formPeriod.expiryDate = ''
			this.$alert('选择的生效日期有误，请重新选择生效日期！', '提示').then(() => {})
		},
		daysBetween(from, to) {
			let days = (to - from) / 24 / 3600 / 1000 + ''
			return parseInt(days) + 1
		},
		//如果去除投保年，切换企业可投年，则添加
		addYear() {
			if (this.isDealYear) {
				let tempTerm = this.findObject(this.optionPeriod.column, 'term')
				tempTerm.dicData.unshift({
					label: '1年',
					value: '12',
				})
				this.isDealYear = false
			}
		},
		//去除投保年，并且把状态调整为确认
		removeYear() {
			if (this.isDealYear) {
				return
			}
			//处理option
			let tempTerm = this.findObject(this.optionPeriod.column, 'term')
			tempTerm.dicData = tempTerm.dicData.filter((itemData) => {
				return !itemData.value.includes('12')
			})
			if (!this.optionPeriod.submitBtn && this.formPeriod.term == 12) {
				//如果选年了，则重新选
				//去掉label
				this.formPeriod.term = ''
				this.formPeriod.expiryDate = ''
				this.onCheckPeriodResult(false)
			}
			this.isDealYear = true
		},
		onClearOtherData(tempPlanData) {
			//删除空数据
			for (let tempPlanDataKey in tempPlanData) {
				if (tempPlanDataKey.includes('$')) {
					delete tempPlanData[tempPlanDataKey]
				}
			}
		},
		//判断数据都完成了
		isAllDataNoReady(formData) {
			//循环option column  用find循环
			return this.optionPeriod.column.find(({prop = '', display = false}) => display && !formData[prop])
		},
		//是否确定
		isConfirm() {
			return this.optionPeriod.submitBtn
		},
		//处理延迟生效时间
		async onDelayTime() {
			//不是批增
			if (this.isAdd || this.choiceDataRange.length <= 0 || this.envConfig.isBxXsm()) {
				return
			}
			//获取主渠道参数
			let {distAccount = {}} = this.userInfo
			let insureStartDaysTemp = 0
			if (!this.validatenull(distAccount)) {
				let result = await getChannelMainInfo()
				let {insureStartDays = '0'} = result.data.data || {}
				insureStartDaysTemp = parseInt(insureStartDays) * 24 * 60 * 60 * 1000
			}
			let [min, max = ''] = this.choiceDataRange
			let tempMin = new Date(`${min} 00:00:00`).getTime() + insureStartDaysTemp
			let tempMax = new Date(`${max} 00:00:00`).getTime()

			//处理不可选时间
			let effectiveDate = this.findObject(this.optionPeriod.column, 'effectiveDate')

			effectiveDate.pickerOptions = {
				disabledDate: (time) => {
					let result
					if (!this.validatenull(max)) {
						result = time.getTime() > tempMax || time.getTime() < tempMin
					} else {
						result = time.getTime() < tempMin
					}
					return result
				},
			}
			effectiveDate.value = new Date(tempMin)
		},
		onChangeEffectiveData({minEffDate = '', maxEffDate = ''}) {
			//通过企业改变方案名称
			if (minEffDate !== '' && maxEffDate !== '') {
				console.log('onChangeEffectiveData -------', minEffDate, maxEffDate)
				//设置生效，和失效日期
				this.optionPeriod.column.forEach((itemData) => {
					let {prop, range = []} = itemData
					if (prop === 'effectiveDate' && range.length === 2) {
						if (range[0] !== minEffDate || range[1] !== maxEffDate) {
							let {effectiveDate = ''} = this.formPeriod
							if (effectiveDate !== '') {
								if (effectiveDate.includes('00:00:00')) {
									effectiveDate = effectiveDate.replace(' 00:00:00', '')
								}
								console.log('onChangeEffectiveData ---effectiveDate----', effectiveDate)
								//判断选择的日期是不是在新的日期里
								let choiceDate = new Date(effectiveDate).getTime()
								if (choiceDate < new Date(minEffDate).getTime() || choiceDate > new Date(maxEffDate).getTime()) {
									this.formPeriod.effectiveDate = ''
									this.formPeriod.expiryDate = ''
									this.onCheckPeriodResult(false)
									setTimeout(() => {
										this.$alert(
											'因保司核保政策调整，生效日期发生改变，需要重新选择，带来不便，敬请谅解！',
											'提示',
										).then(() => {})
									}, 600)
								}
							}
							itemData.range = [minEffDate, maxEffDate]
							this.choiceDataRange = itemData.range
							itemData.pickerOptions = {
								disabledDate: (time) => {
									//禁止投保时间
									return (
										time.getTime() < new Date(`${minEffDate} 00:00:00`).getTime() ||
										time.getTime() > new Date(`${maxEffDate} 23:59:59`).getTime()
									)
								},
							}
						}
					}
				})
			}
		},
		//弹出提示
		onShowInsureData() {
			let tempMonth = this.getDateMill(new Date(this.formPeriod.effectiveDate))
			if (tempMonth && this.addPriceType === 'M') {
				this.$confirm(`你当前的保费会按照【${tempMonth}个月】收取，请仔细确认是否继续批增？`, '提示', {
					confirmButtonText: '确认投保',
					cancelButtonText: '重新选择日期',
				})
					.then(() => {
						//确认
						this.onCheckPeriodResult(true)
					})
					.catch(() => {})
			} else {
				this.onCheckPeriodResult(true)
			}
		},
		//获取当前日期与保单起始日期毫秒值, 参数为选择的日期
		getDateMill(date) {
			let {expiryDate, effectiveDate} = this.formPeriod

			//计算选择的日期和生效日期差几个月
			let choiceMonth = date.getMonth()
			//effectiveBeginDate 生效时间
			let tempEffectiveData = new Date(this.effectiveBeginDate)
			let effectiveMonth = tempEffectiveData.getMonth()
			let tempMonth = choiceMonth >= effectiveMonth ? choiceMonth - effectiveMonth : choiceMonth + 12 - effectiveMonth
			console.log('选择的日期和生效日期差:---', tempMonth)

			let oneDay = 24 * 60 * 60 * 1000
			//同一个月的，当前日期是否在 大于失效日期 - 3天
			if (tempMonth === 0) {
				//defeasanceDate 失效日期
				return (new Date(expiryDate).getTime() - Date.now()) / oneDay <= 4 ? 1 : 0
			}
			//非同一个月
			//保单生效日期+相差的月份
			let year = tempEffectiveData.getFullYear()
			let month = tempEffectiveData.getMonth()
			let day = tempEffectiveData.getDate()
			year = year + parseInt((month + tempMonth) / 12)
			month = (month + tempMonth) % 12
			let maxDayCount = new Date(year, month + 1, 0).getDate()
			if (day > maxDayCount) {
				day = maxDayCount
			}
			let tempMill = new Date(`${year}-${month + 1}-${day - 1} 23:59:59`).getTime()
			console.log(`${year}-${month + 1}-${day - 1}`, effectiveDate, tempMill - date.getTime())
			//获取到相差几个月的时间 - 选择的时间，是否在4天内
			return date.getTime() >= tempMill - 4 * oneDay && date.getTime() <= tempMill
				? this.getTermData - tempMonth + 1
				: 0
		},
		onSetPeriodMockData() {
			this.optionPeriod.column.forEach((itemData) => {
				let {dicData = [], prop = '', range = []} = itemData
				if (dicData.length > 0) {
					this.formPeriod[prop] = dicData[0].value
				} else if (range.length > 0) {
					this.formPeriod.effectiveDate = `${range[0]} 00:00:00`
				}
			})
		},
		onDealUnit() {
			let tempTerm = this.findObject(this.optionPeriod.column, 'term')
			let {dicData = [], value: valueW = ''} = tempTerm || {}
			let tempUnit = ''
			if (dicData && dicData.length > 0) {
				tempTerm.dicData = dicData.map(({value, label, addition: {termUnit = ''} = {}}) => {
					if (valueW === value) {
						tempUnit = termUnit
					}
					return {value: `${value}_${termUnit ? termUnit : 'M'}`, label}
				})
				let {term = ''} = this.formPeriod
				if (valueW && !term && tempUnit) {
					this.formPeriod.term = `${valueW}_${tempUnit}`
				}
			}
		},
		onGetCheckData() {
			let tempPeriodData = this.deepClone(this.formPeriod)
			//判断选项中term有么有 _单位
			let {term = ''} = tempPeriodData
			if (term && term.includes('_')) {
				let [one, two] = term.split('_')
				tempPeriodData.term = one
				tempPeriodData.termUnit = two
			}
			return tempPeriodData
		},
		//获取可选时间范围
		async onGetPeriodRange(tempData) {
			//判断选项中term有么有 _单位
			let {term = ''} = tempData
			if (term && term.includes('_')) {
				let [one, two] = term.split('_')
				tempData.term = one
				tempData.termUnit = two
			}
			let baseQues = {
				productId: this.productId,
				sourceProductId: this.sourceProductId,
				orderInfo: tempData,
			}
			let res = (await getInsureBaseConfig(baseQues)) || {}
			//获取数据
			let {code = -1, data = {}} = res.data || {}
			if (code !== 0) {
				return false
			}
			this.lastTerm = this.formPeriod.term
			let {
				orderForm: {
					effectiveDate: {range = []},
				},
			} = data
			if (range.length !== 2) {
				this.$message.error('保单起期范围有误！')
				return false
			}
			//时间范围
			let [one, two] = range
			let [oneLast, twoLast] = this.choiceDataRange
			console.log('当前时间范围', one, two, oneLast, twoLast)
			if (one !== oneLast || two !== twoLast) {
				//提示并且清理数据
				this.$alert('保单起期时间范围已改变，请重新选择！', '提示', {confirmButtonText: '我知道了'}).then(() => {
					this.formPeriod.effectiveDate = ''
					this.formPeriod.expiryDate = ''
					//更改生效范围
					this.choiceDataRange = range
					let tempEffectiveDate = this.findObject(this.optionPeriod.column, 'effectiveDate')
					Object.assign(tempEffectiveDate, {
						range,
						pickerOptions: {
							disabledDate: (time) => {
								//禁止投保时间
								return (
									time.getTime() < new Date(`${range[0]} 00:00:00`).getTime() ||
									time.getTime() > new Date(`${range[1]} 23:59:59`).getTime()
								)
							},
						},
					})
				})
				return false
			}
			return true
		},
		//动态处理数据显示和隐藏
		onChangeOption(newVal) {
			this.optionPeriod.column.forEach((itemData) => {
				let {prop = ''} = itemData
				let {visibleConditions = []} = this.policyFormAllData[prop] || {}
				if (visibleConditions.length > 0) {
					let isShow = newVal === visibleConditions[0].value
					itemData.display = isShow
					if (!isShow) {
						//从formPeriod中删除
						delete this.formPeriod[prop]
					} else {
						//加入formPeriod
						this.$set(this.formPeriod, prop, '')
					}
				}
			})
		},
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
	padding: 20px 20px 0 20px;
}
</style>
